export class PageElementSpec <T> {
    value?: T | undefined;
    key: string;
    label: string;
    readOnly?: boolean;
    visible?: boolean;
    elementType?: string;
    style?: string;
    format?: string;
    pattern?: string;
    // options: {label: string, value: string}[];

    // Additional dynamic fields
    href?: string;
    placeholder?: string;
    src?: string;
        
    constructor(options: {
        value?: T;
        key?: string;
        label?: string;
        readOnly?: boolean;
        visible?: boolean;
        elementType?: string;
        style?: string;
        format?: string;
        pattern?: string;
        href?: string;
        placeholder?: string;
        src?: string;
      } = {}) {
      this.value = options.value;
      this.key = options.key ?? '';
      this.label = options.label === undefined ? '' : options.label + ':';
      this.readOnly = options.readOnly ?? true;
      this.visible = options.visible ?? true;
      this.elementType = options.elementType || 'text';
      this.style == options.style;
        // Assign additional fields
        this.href = options.href ?? '';
        this.placeholder = options.placeholder ?? '';
        this.src = options.src ?? '';
    }
}
